export default __webpack_public_path__ + "static/media/Dbacks.fa355a32.png";